import MuiRadio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

interface RadioOption {
  value?: string;
  label?: string;
  disabled?: boolean;
}

interface RadioProps {
  name: string;
  index: number;
  option: RadioOption | string;
  checked?: boolean;
  callback: (index: number, checked: boolean | undefined, value: string | RadioOption | undefined) => void;
}

export function Radio(props: RadioProps) {
  const optionObject = typeof props.option === 'object' && props.option !== null ? props.option : undefined;
  const optionValue = optionObject?.value ?? props.option;
  const label: React.ReactNode =
    optionObject?.label ?? (typeof props.option === 'string' ? props.option : optionObject?.value);
  const disabled = Boolean(optionObject?.disabled);

  return (
    <FormControlLabel
      value={optionValue}
      disabled={disabled}
      control={
        <MuiRadio
          checked={Boolean(props.checked)}
          onChange={() => {
            if (disabled) return;
            props.callback(props.index, props.checked, optionValue);
          }}
          name={props.name}
          size="small"
        />
      }
      label={label}
      sx={{
        margin: 0,
        '.MuiFormControlLabel-label': {
          textTransform: 'none',
          opacity: disabled ? 0.5 : 1,
        },
      }}
    />
  );
}
